module.exports = __webpack_public_path__ + "media/images/new-24-8684360b31b0886ddab274cbd5102053.png";